import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <noscript>You need to enable JavaScript to run this app.</noscript>
    <App />
  </React.StrictMode>
);


reportWebVitals();
